import { useEffect, useRef } from "react";
import * as $ from "jquery";
import publicspaces from "../../../assets/images/publicspaces.png";
import communities from "../../../assets/images/communities.png";
import risk from "../../../assets/images/risk.png";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
import "./Adjustments.scss";
const Adjustments = () => {
  const adjustmentstitle = useRef();
  const carouselfirst = useRef();
  useEffect(() => {
    $(window).scroll(function (event) {
      let scrollPosition = $(this).scrollTop();
    });
  }, []);
  return (
    <section>
      <div className="cids adjustments">
        <div className="container cid-content">
          <div id="adjustments-title" className="title" ref={adjustmentstitle}>
            The pathway to resilience calls for{" "}
            <span>
              investing over $9Bn by 2035 to avert $33-39Bn in damages
            </span>
          </div>

          <OwlCarousel className="owl-theme mobile" margin={0} nav items={1}>
            <div
              id="carousel-first"
              ref={carouselfirst}
              className="item cid-carousel adjustments-carousel"
            >
              <div className="custom-row">
                <div className="cid-title adjustments-title">
                  Build Resilient Infrastructures &amp; Public Spaces
                </div>
                <img src={publicspaces} alt="slr" className="cid-img" />
              </div>
              <div className="custom-col">
                <div className="cid-driver-bullet-parent adjustments-desc">
                  Investing in{" "}
                  <span>
                    solutions to reduce exposure of key infrastructure,
                  </span>{" "}
                  such as transportation, power, water, drainage, and
                  communication assets{" "}
                  <span>to build a climate-resilient city</span>
                </div>
              </div>
            </div>
            <div className="item cid-carousel adjustments-carousel">
              <div className="custom-row">
                <div className="cid-title adjustments-title">
                  Protecting Vulnerable Communities & Groups
                </div>
                <img src={communities} alt="extreme-heat" className="cid-img" />
              </div>
              <div className="custom-col">
                <div className="cid-driver-bullet-parent adjustments-desc">
                  Adaption{" "}
                  <span>
                    solutions targeted at the most vulnerable populations
                  </span>{" "}
                  exposed to the severe effects of climate change, including low
                  income communities
                </div>
              </div>
            </div>
            <div className="item cid-carousel adjustments-carousel">
              <div className="custom-row">
                <div className="cid-title adjustments-title">
                  Utilizing Nature-Based & Carbon-Negative Solutions
                </div>
                <img
                  src={risk}
                  alt="extreme-precipitation"
                  className="cid-img"
                />
              </div>
              <div className="custom-col">
                <div className="cid-driver-bullet-parent adjustments-desc">
                  Resilience and mitigation can go hand-in-hand in many cases,
                  utilizing{" "}
                  <span>nature-based solutions like mangrove restoration</span>{" "}
                  and urban canopies to address the climate crises
                </div>
              </div>
            </div>
          </OwlCarousel>
          <OwlCarousel
            className="owl-theme desktop adjustments-carousel-animated"
            margin={0}
            nav
            items={3}
          >
            <div
              id="carousel-first"
              ref={carouselfirst}
              className="item cid-carousel adjustments-carousel desktop"
            >
              <div className="custom-row">
                <div className="cid-title adjustments-title">
                  Build Resilient Infrastructures &amp; Public Spaces
                </div>
                <img src={publicspaces} alt="slr" className="cid-img" />
              </div>
              <div className="custom-col">
                <div className="cid-driver-bullet-parent adjustments-desc">
                  Investing in{" "}
                  <span>
                    solutions to reduce exposure of key infrastructure,
                  </span>{" "}
                  such as transportation, power, water, drainage, and
                  communication assets{" "}
                  <span>to build a climate-resilient city</span>
                </div>
              </div>
            </div>
            <div className="item cid-carousel adjustments-carousel desktop">
              <div className="custom-row">
                <div className="cid-title adjustments-title">
                  Protecting Vulnerable Communities & Groups
                </div>
                <img src={communities} alt="extreme-heat" className="cid-img" />
              </div>
              <div className="custom-col">
                <div className="cid-driver-bullet-parent adjustments-desc">
                  Adaption{" "}
                  <span>
                    solutions targeted at the most vulnerable populations
                  </span>{" "}
                  exposed to the severe effects of climate change, including low
                  income communities
                </div>
              </div>
            </div>
            <div className="item cid-carousel adjustments-carousel desktop">
              <div className="custom-row">
                <div className="cid-title adjustments-title">
                  Utilizing Nature-Based & Carbon-Negative Solutions
                </div>
                <img
                  src={risk}
                  alt="extreme-precipitation"
                  className="cid-img"
                />
              </div>
              <div className="custom-col">
                <div className="cid-driver-bullet-parent adjustments-desc">
                  Resilience and mitigation can go hand-in-hand in many cases,
                  utilizing{" "}
                  <span>nature-based solutions like mangrove restoration</span>{" "}
                  and urban canopies to address the climate crises
                </div>
              </div>
            </div>
          </OwlCarousel>
        </div>
      </div>
    </section>
  );
};

export default Adjustments;
